import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_SHARE_GOAL_UX_EXPERIMENT = defineFcm('psf_share_goal_ux_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				experimentName: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'Share Page (psf/share) Goal-Setting UX',
		description:
			'Rollout kill switch for the share goal UX experiment (4 arms: control, fake_control, variant_1, variant_2), independent of Experiment Service assignment.\n\nhttps://change.atlassian.net/browse/CHANGE-97348',
		import: false,
		template: {
			enabled: false,
			experimentName: 'psf_share_goal_ux_experiment',
		},
	});
